<mat-form-field>
  <mat-label>Number Control Input</mat-label>
  <input matInput [ngModel]="controlValue|async" (ngModelChange)="controlValue.next($event)" name="controlValue" type="number">
</mat-form-field>

